import AppConfig from '@/utils/app-config.mjs';
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { callToGetLOAReviewDetails, setIsCertificateStatusUpdated } from '../ducks/slice';
import { getLOAReviewDetails, getLOAReviewDetailsLoading } from './selector';
import { getDocumentsRequiredDetails, getDocumentsRequiredDetailsLoading, getIsDealerDetailsLoading, getValidLicenseRecord } from '@/queue/ducks/selectors';
import { callToGetDocumentStatus, callToGetLicenseRecordDetails, setDocumentsRequiredDetails, setDocumentsRequiredDetailsLoading } from '@/queue/ducks/slice';
import { LOAReview, ReviewConfirmation } from '@/model/license-review.mjs';
import { getFormattedDate, getFormattedDateTime } from '@/queue/elements/value-formatters/date-formatter.mjs';
import { fixTimezoneOffset, trimDate } from '@/queue/utils';
import { getIsGlobalAdmin } from '@/redux/app-selectors';
import FFLDetailModal from '@/explore/ffl-detail/FFLDetailModal';
import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Grid, GridItem, Image, Select, Spinner, Table, TableContainer, Tbody, Textarea, Tooltip, useDisclosure } from '@chakra-ui/react';
import { updateLOAApprovalStatus } from '@/api/apis';
import { loaApprovalValidation, regexFullLicense, textareaLengthValidation } from '@/queue/ducks/validationSchema';
import s3Utils from '@/utils/s3Utils';
import { ChevronRightIcon } from '@chakra-ui/icons';
import TableElement from '@/table/TableElement';
import ControlledInput from '@/common/ControllerInput';
import { getFormattedTextForManualReview, getSourceTextForApprovalPage } from '@/utils/utils';
import { normalizeRejectedReasonFromApi, reviewRejectedReasonsFflLoa, stepMapping } from '@/utils/constants';
import { MapInteractionCSS } from 'react-map-interaction';
import ReviewConfirmationModal from '@/common/ReviewConfirmationModal';
import FlatDatePickr from '@/common/Flatpickr';

const LOAApprovalPage = () => {

    const dispatch = useDispatch();
    const params = useParams();
    const loaReviewDetails = getLOAReviewDetails();
    const loaReviewDetailsLoading = getLOAReviewDetailsLoading();
    const documentsRequiredDetails = getDocumentsRequiredDetails();
    const validLicenseRecordDetails = getValidLicenseRecord();
    const documentsRequiredDetailsLoading = getDocumentsRequiredDetailsLoading();
    const isDealerDetailsLoading = getIsDealerDetailsLoading();

    const fullURL = (path: string) => `${AppConfig.SOTTaxStampsBaseURL}${encodeURIComponent(path)}`;

    const endDateSpecialTaxPickerRef = useRef<any>(null);
    const expiryDatePickerRef = useRef<any>(null);

    const [dealer_id, setDealerId] = useState<string>('');
    const [loaReview, setLoaReview] = useState<LOAReview | null>(null);
    const [reviewConfirmation, setReviewConfirmation] = useState<ReviewConfirmation>({
        header: "",
        isCancelBtnDisable: false,
        isConfirmBtnDisable: false,
        isConfirmBtnLoading: false,
        isSaveBtnLoading: false,
        rejectedReason: "",
        note: "",
        error: "",
        status: "",
    });
    const [reviewInputVal, setReviewInputVal] = useState<any>({
        rejectReason: "",
        note: "",
    });
    const [downloadingFile2, setDownloadingFile2] = useState<boolean>(false);

    const {
        isOpen: isReviewConfirmationMadalOpen,
        onClose: onCloseReviewConfirmationModal,
        onOpen: onOpenReviewConfirmationModal
    } = useDisclosure();

    const getLOADetails = () => {
        if (params.id && !loaReviewDetailsLoading && !documentsRequiredDetailsLoading) {
            dispatch(setDocumentsRequiredDetailsLoading(true))
            dispatch(callToGetLOAReviewDetails({
                id: params.id
            }))
        }
    }

    useEffect(() => {
        getLOADetails()
    }, [params?.id])

    useEffect(() => {
        if (loaReview?.license_key && (loaReview?.license_key?.length === 8 || loaReview?.license_key?.length === 20)) {
            dispatch(callToGetLicenseRecordDetails({ id: loaReview?.license_key }));
        }
        else {
            dispatch(setDocumentsRequiredDetails({}));
            setDealerId('');
        }
    }, [loaReview?.license_key]);


    useEffect(() => {
        if (validLicenseRecordDetails?.dealerId && validLicenseRecordDetails?.fullLicenseKeys?.[0]) {
            dispatch(callToGetDocumentStatus({ id: validLicenseRecordDetails?.fullLicenseKeys?.[0] }));
            setDealerId(validLicenseRecordDetails?.dealerId);
        } else {
            setLoaReview((prevState: any) => ({
                ...prevState,
                errors: { ...(prevState?.errors || {}), 'full_license_key': 'Enter valid license number' }
            }))
            setDealerId('');
        }
    }, [validLicenseRecordDetails]);

    useEffect(() => {
        if (loaReview === null || loaReviewDetails?.id) {
            setReviewInputVal({
                rejectReason: "",
                note: "",
            })
            setLoaReview({
                ...loaReviewDetails,
                issue_date: (loaReviewDetails?.issue_date ? getFormattedDate(trimDate(loaReviewDetails?.issue_date)) : "") as string,
                expiry_date: (loaReviewDetails?.expiry_date ? getFormattedDate(trimDate(loaReviewDetails?.expiry_date)) : "") as string,

            })
            setReviewInputVal({
                rejectReason: normalizeRejectedReasonFromApi(loaReviewDetails?.rejected_reason ?? null) || "",
                note: loaReviewDetails?.note || "",
            })
            setLoaReview(loaReviewDetails);
            setDealerId(loaReviewDetails?.dealer_id || "");
            if (loaReview?.license_key && (loaReview?.license_key?.length === 8 || loaReview?.license_key?.length === 20)) {
                dispatch(callToGetLicenseRecordDetails({ id: loaReview?.license_key }));
            } else {
                dispatch(setDocumentsRequiredDetails({}));
                dispatch(setDocumentsRequiredDetailsLoading(false));
                setDealerId('');
            }
        }
    }, [loaReviewDetails])

    const openEndDateSpecialTaxDatePicker = () => {
        if (endDateSpecialTaxPickerRef.current) {
            endDateSpecialTaxPickerRef.current.setOpen(true);
        }
    };

    const openExpiryDatePicker = () => {
        if (expiryDatePickerRef.current) {
            expiryDatePickerRef.current.setOpen(true);
        }
    };

    const convertLicenseInEightDigits = (value: string) => value ? `${value[0]}${value.slice(2, 4)}${value.slice(15)}` : "";

    const checkStatus = (currentStatus: string | undefined, status: string) => {
        return currentStatus === status;
    };

    const onDateChange = async (date: Date | null, fieldName: string) => {
        if (!date) {
            setLoaReview((prevState: any) => ({
                ...prevState,
                [fieldName]: null,
                errors: { ...(prevState.errors || {}), [fieldName]: '' }
            }));
            return;
        }

        console.log({ fieldName: fieldName, value: getFormattedDate(date.toDateString()) });
        
        setLoaReview((prevState: any) => {
            const newValue = getFormattedDate(date.toDateString());
            const updatedState = {
                ...prevState,
                [fieldName]: newValue,
                errors: { ...(prevState.errors || {}), [fieldName]: '' }
            };

            // Cross-validation for date logic
            if (fieldName === 'issue_date' && prevState.expiry_date && newValue) {
                const issueDate = new Date(newValue);
                const expiryDate = new Date(prevState.expiry_date);
                
                if (issueDate > expiryDate) {
                    updatedState.errors = {
                        ...updatedState.errors,
                        issue_date: 'Issue date cannot be later than expiry date.'
                    };
                } else {
                    // Clear expiry_date error if issue_date is now valid
                    const { expiry_date, ...restErrors } = updatedState.errors;
                    updatedState.errors = restErrors;
                }
            }
            
            if (fieldName === 'expiry_date' && prevState.issue_date && newValue) {
                const issueDate = new Date(prevState.issue_date);
                const expiryDate = new Date(newValue);
                
                if (expiryDate < issueDate) {
                    updatedState.errors = {
                        ...updatedState.errors,
                        expiry_date: 'Expiry date cannot be earlier than issue date.'
                    };
                } else {
                    // Clear issue_date error if expiry_date is now valid
                    const { issue_date, ...restErrors } = updatedState.errors;
                    updatedState.errors = restErrors;
                }   
            }

            return updatedState;
        });
    };

    const onOpenCertificateStatus = async (status: string) => {
        if (status === "approved") {
            await validateFields();
            setReviewConfirmation((prevState: any) => ({
                ...prevState,
                header: "Do you want to Approve this license",
                status: status
            }))
        } else {
            setReviewConfirmation((prevState: any) => ({
                ...prevState,
                header: "Reason of Rejection",
                status: status
            }))
        }
        onOpenReviewConfirmationModal();
    }

    const updateCertificateStatus = async (status: string, isSaveClicked: boolean = false, isEmailIgnored: boolean = false) => {
        try {
            setReviewConfirmation((prevState: ReviewConfirmation) => ({
                ...prevState,
                isConfirmBtnLoading: !isSaveClicked ? true : isSaveClicked,
                isCancelBtnDisable: true,
                isSaveBtnLoading: isSaveClicked,
            }));
            const response = await updateLOAApprovalStatus({
                id: loaReview?.id,
                license_key: regexFullLicense.test(loaReview?.license_key as string) ? convertLicenseInEightDigits(loaReview?.license_key || "") : loaReview?.license_key,
                dealer_id: loaReview?.dealer_id,
                issue_date: loaReview?.issue_date,
                expiry_date: loaReview?.expiry_date,
                path: loaReview?.path,
                loa_type: loaReview?.loa_type,
                status: status,
                rejected_reason: reviewConfirmation?.rejectedReason,
                note: reviewConfirmation?.note,
                source: loaReview?.source,
                ignoreManualReviewEmail: isEmailIgnored
            });
            if (response.status === 204) {
                dispatch(setIsCertificateStatusUpdated(true));
                getLOADetails();
            }
            closeReviewConfirmationModal();
        } catch (err: any) {
            console.log('ERROR', err);
            if (
                err &&
                err?.response &&
                err.response?.status == 404 &&
                err.response?.data &&
                err.response.data?.Error
            ) {
                setLoaReview((prevState: any) => ({
                    ...prevState,
                    errors: { ...(prevState.errors || {}), 'license_key': err.response.data?.Error }
                }))
            }
        } finally {
            setReviewConfirmation((prevState: ReviewConfirmation) => ({
                ...prevState,
                isConfirmBtnLoading: false,
                isCancelBtnDisable: false,
                isSaveBtnLoading: false,
            }));
        }
    };

    const validateFields = async () => {
        try {
            await loaApprovalValidation.validate(loaReview, { abortEarly: false });
        } catch (error: any) {
            if (error.errors && error.errors.length > 0) {
                const errors = error?.inner?.reduce((acc: { [key: string]: string }, err: any) => {
                    acc[err.path] = err.message;
                    return acc;
                }, {});
                setLoaReview((prevState: any) => ({
                    ...prevState,
                    errors
                }));
                throw new Error(error?.errors[0]);
            }
        }
    };

    const validateField = async (name: string, value: string | Date) => {
        try {
            await loaApprovalValidation.validateAt(name, { [name]: value });
            setLoaReview((prevState: any) => ({
                ...prevState,
                errors: { ...(prevState.errors || {}), [name]: '' }
            }));
        } catch (error: any) {
            if (error.errors && error.errors.length > 0) {
                setLoaReview((prevState: any) => ({
                    ...prevState,
                    errors: { ...(prevState.errors || {}), [name]: error.errors[0] }
                }));
            }
        }
    };

    const onChangeInputs = async (value: string | number, fieldName: string) => {
        if (fieldName === "number_of_months" && value && String(value)?.length > 2) return;
        await validateField(fieldName, value as string);
        if (loaReview?.issue_date && fieldName === "number_of_months") {
            setLoaReview((prevState: any) => ({
                ...prevState,
                [fieldName]: value,
                "expiry_date": getFormattedDate(prevState?.issue_date, (value || 6) as number)
            }));
            return;
        }
        setLoaReview((prevState: any) => ({
            ...prevState,
            [fieldName]: value
        }));
    };

    const handleDownload = async () => {
        const url = fullURL(loaReview?.path || "");
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const blob = await response.blob();
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = loaReview?.path?.split("/").pop() || "";
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading the image:', error);
        }
    };

    const handleChange = async (event: any) => {
        setReviewConfirmation((prevState: ReviewConfirmation) => ({
            ...prevState,
            rejectedReason: event.target.value
        }));
    };

    const handleTextChange = async (event: any) => {
        const value = event.target.value;
        try {
            await textareaLengthValidation.validateAt('textarea', { 'textarea': value });
            setReviewConfirmation((prevState: ReviewConfirmation) => ({
                ...prevState,
                note: event.target.value,
                error: ''
            }));
        } catch (error: any) {
            if (error.errors && error.errors.length > 0) {
                setReviewConfirmation((prevState: ReviewConfirmation) => ({
                    ...prevState,
                    error: error.errors[0]
                }));
            }
        }
    };

    const closeReviewConfirmationModal = () => {
        onCloseReviewConfirmationModal();
        setReviewConfirmation({
            header: "",
            isCancelBtnDisable: false,
            isConfirmBtnDisable: false,
            isConfirmBtnLoading: false,
            isSaveBtnLoading: false,
            rejectedReason: "",
            note: "",
            error: "",
            status: "",
        });
    }

    const disableConfirmButton = () => {
        if (reviewConfirmation.error || (reviewConfirmation.status === "rejected" && !reviewConfirmation.rejectedReason)) {
            return true;
        }
        return false;
    }

    const downloadFile2 = async (path: string) => {
        setDownloadingFile2(true);
        console.log("LOA : ", path);
        console.log("LOA Bucket : ", AppConfig?.licenseReaderBucket);
        await s3Utils.getFile(path, 'licenseReader', { public: '' });
        setDownloadingFile2(false);
    };


    const downloadIcon2 = () => {
        return (
            <>
                {downloadingFile2 ? (
                    <button className="license_details__download-btn download-license-height">
                        <Spinner size="sm" />
                    </button>
                ) : (
                    <Box
                        display={'inline'}
                        position={'relative'}
                        top={'6px'}
                        pl={2}
                    >
                        <Tooltip
                            hasArrow
                            placement="top"
                            label="Download Original LOA"
                            color={'black'}
                            bg={'white'}
                        >
                            <button
                                className="license_details__download-btn download-license-height"
                                onClick={() => downloadFile2(loaReview?.object_path as string)}
                                disabled={!loaReview?.object_path}
                            >
                                <Image src="/images/ui/download.svg" />
                            </button>
                        </Tooltip>
                    </Box>
                )}
            </>
        );
    };

    const downloadIcon = () => {
        return <Box
            display={'inline-block'}
            position={'relative'}
            top={'6px'}
            pl={2}
            cursor={'pointer'}
            onClick={handleDownload}
        >
            <Tooltip
                hasArrow
                placement="top"
                label="Download certificate"
                color={'black'}
                bg={'white'}
            >
                <Image src="/images/ui/download.svg" mr={2} />
            </Tooltip>
            {/* {licenseReview?.license_path?.split("/").pop() || ""} */}
        </Box>
    }

    const onSave = async () => {
        await validateFields();
        await updateCertificateStatus(loaReview?.status ? loaReview?.status.toLowerCase() : "pending", true)
    }

    const getFailedStep = (value: string | number | null) => {
        if (value == null || value === '') return '';
        return stepMapping[String(value)] || '';
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', }}>
            {(loaReviewDetailsLoading || documentsRequiredDetailsLoading) && (
                <Box sx={{ position: 'fixed', zIndex: 1000, height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(0, 0, 0, 0.2)', top: 0, left: 0 }} >
                    <Spinner
                        size="lg"
                    />
                </Box>
            )}
            <Box className="transfer_flex_row" sx={{ marginBottom: 3 }}>
                <Breadcrumb
                    spacing="3px"
                    separator={
                        <ChevronRightIcon className="right-arrow" color="#323232" />
                    }
                >
                    <BreadcrumbItem className="breadcrumb-item">
                        <BreadcrumbLink
                            className="breadcrumb-link"
                            as={Link}
                            to="/admin/loa-approval"
                        >
                            LOA Approval
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem className="breadcrumb-item">
                        <span className="breadcrumb-link breadcrumb-text">
                            LOA Approval Details
                        </span>
                    </BreadcrumbItem>
                </Breadcrumb>
                <Box sx={{ display: 'flex', justifyContent: { base: 'flex-start', lg: 'flex-end' }, flexGrow: 1, flexWrap: 'wrap', paddingTop: { base: 3, lg: 0 } }}>
                    {loaReview?.object_path &&
                        <>
                            <TableElement
                                label={'LOA Preview'}
                                className="license-file-path"
                                renderFunction={downloadIcon}
                                mb={3}
                                type={'review'}

                            />
                            <TableElement
                                label={'Original File'}
                                className="license-file-path"
                                renderFunction={downloadIcon2}
                                mb={3}
                                type={'review'}
                            />
                        </>
                    }
                    <Button
                        // background="#0C1E46"
                        colorScheme="blue"
                        background="#ffffff"
                        color="#0C1E46"
                        border="1px solid #0C1E46"
                        padding="8px 20px"
                        marginRight="20px"
                        isLoading={reviewConfirmation.isSaveBtnLoading}
                        sx={{ outline: 'none !important' }}
                        isDisabled={(loaReview &&
                            loaReview?.errors &&
                            Object.values(loaReview?.errors).some((val) => val !== '') ? true : false)}
                        onClick={() => { onSave() }}
                    >
                        Save
                    </Button>
                    <Button
                        leftIcon= {<Image src="/images/ui/success.svg" />}
                        {...(
                            (checkStatus(loaReview?.status, "approved") || 
                            (loaReview && loaReview?.errors && Object.values(loaReview?.errors).some((val) => val !== ''))
                            ) && 
                            { isDisabled: true }
                        )}
                        {...( { colorScheme: "green", variant: 'outline' })}
                        padding="8px 20px"
                        marginRight="20px"
                        sx={{ outline: 'none !important' }}
                        onClick={() => { onOpenCertificateStatus("approved") }}
                    >
                        {!checkStatus(loaReview?.status, "approved") ? "Approve" : "Approved"}
                    </Button>
                    <Button
                        leftIcon= {<Image src="/images/ui/reject.svg" />}
                        {...(
                            (
                                checkStatus(loaReview?.status, "rejected") || 
                                (loaReview && loaReview?.errors && Object.values(loaReview?.errors).some((val) => val !== ''))
                            )  && 
                            { isDisabled: true }
                        )}
                        {...( { colorScheme: "red", variant: 'outline', padding: "8px 20px" })}
                        onClick={() => { onOpenCertificateStatus("rejected") }}
                        sx={{ outline: 'none !important' }}
                    >
                        {!checkStatus(loaReview?.status, "rejected") ? "Reject" : "Rejected"}
                    </Button>
                </Box>
            </Box>
            <Box className='sot-approval-wrapper'>
                <Box className='sot-approval-details-wrapper'>
                    <Box className='flex-col' sx={{ width: { base: '100%', lg: '32%' } }}>
                        <TableElement noBorder={true} label={
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                License Number
                                {(dealer_id) && (
                                    <img
                                        src="/images/ui/blue-link.svg"
                                        alt="License"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            window.open(`/dealers-search/${dealer_id}`, '_blank');
                                        }}
                                        style={{
                                            width: '16px',
                                            height: '16px',
                                            cursor: 'pointer'
                                        }}
                                    />
                                )}

                            </div>} px={"0"} type={'review'} />
                        <Box sx={{ position: 'relative' }}>
                            <ControlledInput
                                className="loa-tax-stamp__input contact-detail-form__contact-name"
                                type="text"
                                placeholder="XXXXXXXX or X-XX-XXX-XX-XX-XXXXX"
                                value={loaReview?.license_key || ""}
                                onChange={(event: any) =>
                                    onChangeInputs(
                                        event.target.value ? event.target.value?.trim() : "",
                                        'license_key'
                                    )
                                }
                            />
                            {isDealerDetailsLoading && (
                                <Spinner
                                    size="sm"
                                    style={{
                                        position: 'absolute',
                                        right: '8px',
                                        top: '25%',
                                        transform: 'translateY(-50%)',
                                        pointerEvents: 'none'
                                    }}
                                />
                            )}
                        </Box>
                        {loaReview?.errors && loaReview?.errors?.license_key ?
                            <div className="">
                                <div className="edit-error">
                                    {loaReview.errors && loaReview?.errors.license_key && (
                                        <>* {loaReview?.errors.license_key}</>
                                    )}
                                </div>
                            </div> : ""
                        }
                        <Box className="transfer_flex_row doc-status-wrapper" sx={{ gap: '8px', marginTop: '1rem' }}>
                            <Box className={`doc_box ${documentsRequiredDetails.hasValidCertificate ? 'doc_active' : ''}`}>FFL License</Box>
                            <Box className={`doc_box ${documentsRequiredDetails?.hasValidSOT ? 'doc_active' : ''}`}>SOT</Box>
                            <Box className={`doc_box ${documentsRequiredDetails?.hasValidLOA ? 'doc_active' : ''}`}>LOA</Box>
                        </Box>
                        <TableElement noBorder={true} label={'LOA Issue Date'} px={"0"} type={'review'}>
                            <FlatDatePickr
                                label=""
                                value={fixTimezoneOffset(loaReview?.issue_date as any) || null}
                                onDateChange={(date: Date) => onDateChange(date, 'issue_date')}
                                options={{
                                    placeholderText: '-Issue Date-'
                                }}
                                classNameValue="transfer-form__input order-date-picker"
                            />
                            {loaReview?.errors && loaReview?.errors?.issue_date ?
                                <div className="">
                                    <div className="edit-error">
                                        {loaReview.errors && loaReview?.errors.issue_date && (
                                            <>* {loaReview?.errors.issue_date}</>
                                        )}
                                    </div>
                                </div> : ""
                            }
                        </TableElement>
                        <Box className='loa-expiry-wrapper'>
                            <TableElement noBorder={true} label={'LOA Expiry Date'} px={"0"} type={'review'}>
                                <FlatDatePickr
                                    label=""
                                    value={fixTimezoneOffset(loaReview?.expiry_date as any) || null}
                                    onDateChange={(date: Date) => { onDateChange(date, 'expiry_date') }}
                                    options={{
                                        placeholderText: '-Expiry Date-',
                                        ...(loaReview?.issue_date && { minDate: new Date(loaReview.issue_date) })
                                    }}
                                    classNameValue="transfer-form__input order-date-picker"
                                />
                                {loaReview?.errors && loaReview?.errors?.expiry_date ?
                                    <div className="">
                                        <div className="edit-error">
                                            {loaReview.errors && loaReview?.errors.expiry_date && (
                                                <>* {loaReview?.errors.expiry_date}</>
                                            )}
                                        </div>
                                    </div> : ""
                                }
                            </TableElement>
                        </Box>
                    </Box>
                    <Box className='flex-col' sx={{ width: { base: '100%', lg: '32%' } }}>
                        <TableElement noBorder={true} label={'ATF Business Name'} px={"0"} type={'review'}>
                            {documentsRequiredDetails?.businessName || loaReview?.business_name || '-'}
                        </TableElement>
                        <TableElement noBorder={true} label={'ATF Premises Address'} px={"0"} type={'review'} >
                            {documentsRequiredDetails?.premiseAddress?.street && <>
                                {documentsRequiredDetails?.premiseAddress?.street}, {documentsRequiredDetails?.premiseAddress?.city}, {documentsRequiredDetails?.premiseAddress?.state}, {documentsRequiredDetails?.premiseAddress?.zipCode}
                            </>}
                        </TableElement>
                        <TableElement noBorder={true} label={'ATF Mailing Address'} px={"0"} type={'review'} >
                            {documentsRequiredDetails?.mailingAddress?.street && <>
                                {documentsRequiredDetails?.mailingAddress?.street}, {documentsRequiredDetails?.mailingAddress?.city}, {documentsRequiredDetails?.mailingAddress?.state}, {documentsRequiredDetails?.mailingAddress?.zipCode}
                            </>}
                        </TableElement>
                        <TableElement noBorder={true} label={'ATF Expiry Date'} px={"0"} type={'review'}>
                            {documentsRequiredDetails?.atfExpiryDate ? getFormattedDate(fixTimezoneOffset(documentsRequiredDetails?.atfExpiryDate as any)) : ''}
                        </TableElement>
                        {/* <TableElement noBorder={true} label={'ATF Expiry Date'} px={"0"} type={'review'}>
                            <FlatDatePickr
                                label=""
                                value={fixTimezoneOffset(documentsRequiredDetails?.atfExpiryDate as any) || null}
                                onDateChange={(date: Date) => { }}
                                options={{ disabled : true }}
                                classNameValue="transfer-form__input order-date-picker"
                            />
                        </TableElement> */}

                    </Box>
                    <Box className='flex-col' sx={{ width: { base: '100%', lg: '32%' } }}>
                        <TableElement label={'Status'} type="review" mb={3}>
                            {loaReview?.status}
                        </TableElement>
                        <TableElement label={'Source of LOA'} type="review" mb={3}>
                            {getSourceTextForApprovalPage(loaReview?.source, 'LOA')}
                        </TableElement>
                        <TableElement label={'Uploaded Date'} type="review" mb={3}>
                            {loaReview?.created_at
                                ? getFormattedDateTime(new Date(loaReview?.created_at)) : ''}
                        </TableElement>
                        <TableElement label={'Failure Reason'} type="review" mb={3}>
                            {getFailedStep(loaReview?.error_code || null)}
                        </TableElement>
                        <TableElement noBorder={true} label={'Rejection Reason'} px={"0"} type={'review'}>
                            <Select
                                placeholder='Select reason*'
                                my={3}
                                onChange={(event) => {
                                    setReviewConfirmation({
                                        ...reviewConfirmation,
                                        rejectedReason: event.target.value,
                                    })
                                    setReviewInputVal({ ...reviewInputVal, rejectReason: event.target.value })
                                }}
                                disabled={!checkStatus(loaReview?.status, "rejected")}
                                required
                            >{
                                    Object.entries(reviewRejectedReasonsFflLoa).map(([key, val]) => <option value={val as string} selected={val === reviewInputVal?.rejectReason}>{val as string}</option>)
                                }
                            </Select>
                        </TableElement>
                        <TableElement noBorder={true} label={'Rejection Note'} px={"0"} type={'review'}>
                            <Textarea
                                // isDisabled={true}
                                name="rejected_reason"
                                className="sot-transfer-form__textarea"
                                value={reviewInputVal?.note || ""}
                                disabled={checkStatus(loaReview?.status, "pending")}
                                onChange={(e) => {
                                    setReviewConfirmation({
                                        ...reviewConfirmation,
                                        note: e.target.value,
                                    })
                                    setReviewInputVal({
                                        ...reviewInputVal,
                                        note: e.target.value,
                                    })
                                }}
                            />
                        </TableElement>
                        <TableElement noBorder={true} label={'Manual Review Requested By'} px={"0"} type={'review'}>
                            {loaReview?.action_performed_by
                                ? getFormattedTextForManualReview(loaReview?.action_performed_by, loaReview?.manual_review_requested_by) : ''}
                        </TableElement>
                        <TableElement noBorder={true} label={'Manual Review Requested At'} px={"0"} type={'review'}>
                            {loaReview?.manual_review_requested_at
                                ? getFormattedDateTime(loaReview?.manual_review_requested_at) : ''}
                        </TableElement>
                    </Box>
                </Box>
                <Box className='sot-preivew-wrapper'>
                    {
                        loaReview?.path && !(loaReview?.path.split('.').pop() === 'pdf') ?
                            <MapInteractionCSS
                                showControls
                                defaultValue={{
                                    scale: 1,
                                    translation: { x: 0, y: 20 }
                                }}
                                minScale={0.5}
                                maxScale={3}
                                translationBounds={{
                                    xMax: 400,
                                    yMax: 200
                                }}
                                btnClass={'map-interection-buttons'}
                            >
                                <Image src={loaReview?.path ? fullURL(loaReview?.path) : ""} alt='loa-image' className='loa-image' />
                            </MapInteractionCSS> :
                            <iframe src={loaReview?.path ? fullURL(loaReview?.path) : ""} name={"LOA License Preview"} title={"LOA License Preview"} id='loa-license-iframe' className='loa-license-preview'></iframe>
                    }
                </Box>
            </Box>
            {/* <Grid templateColumns={{ base: '1fr', md: '50% 50%', xl: '19% 19% 19% 39%' }} gap={6}>
                <GridItem sx={{ paddingRight: { base: 0, md: 8 } }}>

                    <TableContainer className='loa-table-container' flex={1}>
                        <Table>
                            <Tbody>
                                <Grid
                                    templateRows='repeat(1, 1fr)'
                                    templateColumns='repeat(1, 1fr)'
                                    columnGap={6}
                                >
                                    <Grid
                                        templateRows='50px'
                                        templateColumns='repeat(1, 1fr)'
                                    >
                                        <GridItem>
                                            <TableElement noBorder={true} label={'Source'} px={"0"} />
                                        </GridItem>
                                        <GridItem>
                                            {getSourceTextForApprovalPage(loaReview?.source)}
                                        </GridItem>
                                    </Grid>
                                    <Grid
                                        templateRows='50px'
                                        templateColumns='repeat(1, 1fr)'
                                    >
                                        <GridItem>
                                            <TableElement noBorder={true} label={'License Name'} px={"0"} />
                                        </GridItem>
                                        <GridItem>

                                        </GridItem>
                                    </Grid>
                                    <Grid
                                        templateRows='50px'
                                        templateColumns='repeat(1, 1fr)'
                                    >
                                        <GridItem>

                                        </GridItem>
                                        <GridItem>
                                            <Box></Box>
                                        </GridItem>
                                    </Grid>
                                    <Grid
                                        templateRows='50px'
                                        templateColumns='repeat(1, 1fr)'
                                    >
                                        <GridItem>
                                            <TableElement noBorder={true} label={'Manual Review Requested At:'} px={"0"} />
                                        </GridItem>
                                        <GridItem>
                                            <Box></Box>
                                        </GridItem>
                                    </Grid>


                                    <Grid
                                        templateRows='50px'
                                        templateColumns='repeat(1, 1fr)'
                                    >
                                        <GridItem>
                                            <TableElement noBorder={true} label={'Rejection Reason:'} px={"0"} />
                                        </GridItem>
                                        <GridItem>

                                        </GridItem>
                                    </Grid>
                                    <Grid
                                        templateRows='50px auto'
                                        templateColumns='repeat(1, 1fr)'
                                    >
                                        <GridItem>

                                        </GridItem>
                                        <GridItem>

                                        </GridItem>
                                    </Grid>
                                </Grid>
                            </Tbody>
                        </Table>
                    </TableContainer>
                </GridItem>
                <GridItem sx={{ paddingRight: { base: 0, md: 8 } }}>
                    <TableContainer className='loa-table-container' flex={1}>
                        <Table>
                            <Tbody>
                                <Grid
                                    templateRows='repeat(1, 1fr)'
                                    templateColumns='repeat(1, 1fr)'
                                    columnGap={6}
                                >
                                    <Grid
                                        templateRows='50px'
                                        templateColumns='repeat(1, 1fr)'
                                    >
                                        <GridItem>
                                            <TableElement noBorder={true} label={'Source'} px={"0"} />
                                        </GridItem>
                                        <GridItem>
                                            {getSourceTextForApprovalPage(loaReview?.source)}
                                        </GridItem>
                                    </Grid>
                                    <Grid
                                        templateRows='50px'
                                        templateColumns='repeat(1, 1fr)'
                                    >
                                        <GridItem>
                                            <TableElement noBorder={true} label={'License Name'} px={"0"} />
                                        </GridItem>
                                        <GridItem>
                                            {loaReview?.business_name || '-'}
                                        </GridItem>
                                    </Grid>
                                    <Grid
                                        templateRows='50px'
                                        templateColumns='repeat(1, 1fr)'
                                    >
                                        <GridItem>
                                            <TableElement noBorder={true} label={'Manual Review Requested By:'} px={"0"} />
                                        </GridItem>
                                        <GridItem>
                                            <Box>{loaReview?.action_performed_by
                                                ? getFormattedTextForManualReview(loaReview?.action_performed_by, loaReview?.manual_review_requested_by) : ''}</Box>
                                        </GridItem>
                                    </Grid>
                                    <Grid
                                        templateRows='50px'
                                        templateColumns='repeat(1, 1fr)'
                                    >
                                        <GridItem>
                                            <TableElement noBorder={true} label={'Manual Review Requested At:'} px={"0"} />
                                        </GridItem>
                                        <GridItem>
                                            <Box>{loaReview?.manual_review_requested_at
                                                ? getFormattedDateTime(loaReview?.manual_review_requested_at) : ''}</Box>
                                        </GridItem>
                                    </Grid>
                                    <Grid
                                        templateRows='50px'
                                        templateColumns='repeat(1, 1fr)'
                                    >
                                        <GridItem>
                                            <TableElement noBorder={true} label={'ATF Premises Address :'} px={"0"} />
                                        </GridItem>
                                        <GridItem>
                                            {documentsRequiredDetails?.premiseAddress?.street && <>
                                                {documentsRequiredDetails?.premiseAddress?.street}, {documentsRequiredDetails?.premiseAddress?.city}, {documentsRequiredDetails?.premiseAddress?.state}, {documentsRequiredDetails?.premiseAddress?.zipCode}
                                            </>}
                                        </GridItem>

                                    </Grid>
                                    <Grid
                                        templateRows='50px'
                                        templateColumns='repeat(1, 1fr)'
                                    >
                                        <GridItem>
                                            <TableElement noBorder={true} label={'ATF Mailing Address:'} px={"0"} />
                                        </GridItem>
                                        <GridItem>
                                            {documentsRequiredDetails?.mailingAddress?.street && <>
                                                {documentsRequiredDetails?.mailingAddress?.street}, {documentsRequiredDetails?.mailingAddress?.city}, {documentsRequiredDetails?.mailingAddress?.state}, {documentsRequiredDetails?.mailingAddress?.zipCode}
                                            </>}
                                        </GridItem>
                                    </Grid>
                                    <Grid
                                        templateRows='50px'
                                        templateColumns='repeat(1, 1fr)'
                                    >
                                        <GridItem>
                                            <TableElement noBorder={true} label={'Rejection Reason:'} px={"0"} />
                                        </GridItem>
                                        <GridItem>
                                            <Select
                                                placeholder='Select reason*'
                                                my={3}
                                                onChange={(event) => {
                                                    setReviewConfirmation({
                                                        ...reviewConfirmation,
                                                        rejectedReason: event.target.value,
                                                    })
                                                    setReviewInputVal({ ...reviewInputVal, rejectReason: event.target.value })
                                                }}
                                                disabled={!checkStatus(loaReview?.status, "rejected")}

                                                required
                                            >{
                                                    Object.entries(reviewRejectedReasonsFflLoa).map(([key, val]) => <option value={val as string} selected={val === reviewInputVal?.rejectReason}>{val as string}</option>)
                                                }
                                            </Select>
                                        </GridItem>
                                    </Grid>
                                    <Grid
                                        templateRows='50px auto'
                                        templateColumns='repeat(1, 1fr)'
                                    >
                                        <GridItem>
                                            <TableElement noBorder={true} label={'Note:'} px={"0"} />
                                        </GridItem>
                                        <GridItem>
                                            <Textarea
                                                // isDisabled={true}
                                                name="rejected_reason"
                                                className="sot-transfer-form__textarea"
                                                value={reviewInputVal?.note || ""}
                                                disabled={checkStatus(loaReview?.status, "pending")}
                                                onChange={(e) => {
                                                    setReviewConfirmation({
                                                        ...reviewConfirmation,
                                                        note: e.target.value,
                                                    })
                                                    setReviewInputVal({
                                                        ...reviewInputVal,
                                                        note: e.target.value,
                                                    })
                                                }}
                                            />
                                        </GridItem>
                                    </Grid>
                                </Grid>
                            </Tbody>
                        </Table>
                    </TableContainer>
                </GridItem>

            </Grid> */}
            <ReviewConfirmationModal
                isOpen={isReviewConfirmationMadalOpen}
                onClose={() => {
                    setReviewConfirmation({
                        ...reviewConfirmation,
                        rejectedReason: '',
                        note: '',
                        error: '',
                    })
                    closeReviewConfirmationModal()
                }}
                modalHeader={reviewConfirmation.header}
                isCancelBtnDisable={reviewConfirmation.isCancelBtnDisable}
                isConfirmBtnDisable={disableConfirmButton()}
                isConfirmBtnLoading={reviewConfirmation.isConfirmBtnLoading}
                onClickConfirmBtn={(isEmailIgnored) => { updateCertificateStatus(reviewConfirmation.status, true, isEmailIgnored) }}
                fields={reviewRejectedReasonsFflLoa}
                selectedValue={reviewConfirmation.rejectedReason}
                handleChange={handleChange}
                handleTextChange={handleTextChange}
                hideDropdown={reviewConfirmation.status !== "approved"}
                error={reviewConfirmation.error}
                approvalDetails={loaReview}
            />
        </Box>
    )
}

export default LOAApprovalPage